import React from 'react';
import { MegaphoneIcon, BookOpenIcon, LightbulbIcon, ClockIcon, PlayIcon, UserIcon, PackageIcon, BookMarkedIcon, TimerIcon, RefreshCwIcon, PauseIcon, CheckCircleIcon } from 'lucide-react';
const RedBadge = ({
  label
}: {
  label: string;
}) => <span className="inline-flex items-center px-2 py-0.5 text-white text-xs font-bold rounded" style={{
  backgroundColor: '#CC0000'
}} data-id="element-1981">
    {label}
  </span>;
export function Instructions() {
  return <div className="space-y-8 max-w-3xl" data-id="element-1982">
      {/* 1. WELCOME BANNER */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1983">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-1984">
          Welcome to Desert Sage Seminars!
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-1985">
          Read these quick instructions before you start — it'll save you time.
        </p>
      </div>

      {/* Returning Students Alert */}
      <div className="flex items-start gap-3 rounded-xl border-2 border-amber-400 bg-amber-50 px-5 py-4" data-id="element-1986">
        <MegaphoneIcon className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-1987" />
        <div data-id="element-1988">
          <p className="text-sm font-extrabold text-amber-800 uppercase tracking-wide mb-0.5" data-id="element-1989">
            For Returning Students
          </p>
          <p className="text-sm text-amber-900 leading-relaxed" data-id="element-1990">
            Please update your license expiration date in your{' '}
            <strong data-id="element-1991">Manage Profile</strong> folder on your Dashboard to clear
            the system for your <strong data-id="element-1992">NEW cycle</strong>.
          </p>
        </div>
      </div>

      {/* 2. WHERE TO FIND YOUR CLASSES */}
      <div data-id="element-1993">
        <div className="flex items-center gap-2 mb-4" data-id="element-1994">
          <BookOpenIcon className="h-5 w-5" style={{
          color: '#4A2D8F'
        }} data-id="element-1995" />
          <h2 className="text-lg font-extrabold" style={{
          color: '#4A2D8F'
        }} data-id="element-1996">
            Where to Find Your Classes After Purchase
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1997">
          {/* Card 1 */}
          <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-1998">
            <div className="px-4 py-3 flex items-center gap-2" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1999">
              <PackageIcon className="h-4 w-4 text-yellow-300 flex-shrink-0" data-id="element-2000" />
              <p className="text-white text-xs font-bold leading-tight" data-id="element-2001">
                SELECT YOUR OWN Package
                <span className="block font-normal text-purple-200" data-id="element-2002">
                  (3 or 6 classes)
                </span>
              </p>
            </div>
            <div className="bg-white px-4 py-4" data-id="element-2003">
              <ol className="space-y-2 text-sm text-slate-700" data-id="element-2004">
                <li className="flex gap-2" data-id="element-2005">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2006">
                    1
                  </span>
                  <span data-id="element-2007">
                    Click <strong data-id="element-2008">Available Classes</strong> folder
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2009">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2010">
                    2
                  </span>
                  <span data-id="element-2011">Check the box to choose your class</span>
                </li>
                <li className="flex gap-2" data-id="element-2012">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2013">
                    3
                  </span>
                  <span data-id="element-2014">
                    Click <strong data-id="element-2015">Enroll Me</strong> button
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2016">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2017">
                    4
                  </span>
                  <span data-id="element-2018">
                    Click <strong data-id="element-2019">My Classes</strong> folder
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2020">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2021">
                    5
                  </span>
                  <span data-id="element-2022">
                    Click the class <strong data-id="element-2023">Title</strong> to enter
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2024">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2025">
                    6
                  </span>
                  <span data-id="element-2026">
                    Click <RedBadge label="YOUR CLASS" data-id="element-2027" /> to begin
                  </span>
                </li>
              </ol>
            </div>
          </div>

          {/* Card 2 */}
          <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-2028">
            <div className="px-4 py-3 flex items-center gap-2" style={{
            backgroundColor: '#E8A020'
          }} data-id="element-2029">
              <BookMarkedIcon className="h-4 w-4 text-white flex-shrink-0" data-id="element-2030" />
              <p className="text-white text-xs font-bold leading-tight" data-id="element-2031">
                PRESET Package
                <span className="block font-normal text-yellow-100" data-id="element-2032">
                  (6, 8, or 10 classes)
                </span>
              </p>
            </div>
            <div className="bg-white px-4 py-4" data-id="element-2033">
              <ol className="space-y-2 text-sm text-slate-700" data-id="element-2034">
                <li className="flex gap-2" data-id="element-2035">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#E8A020'
                }} data-id="element-2036">
                    1
                  </span>
                  <span data-id="element-2037">
                    Click <strong data-id="element-2038">My Classes</strong> folder
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2039">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#E8A020'
                }} data-id="element-2040">
                    2
                  </span>
                  <span data-id="element-2041">
                    Click the class <strong data-id="element-2042">Title</strong> to enter
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2043">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#E8A020'
                }} data-id="element-2044">
                    3
                  </span>
                  <span data-id="element-2045">
                    Click <RedBadge label="YOUR CLASS" data-id="element-2046" /> to begin
                  </span>
                </li>
              </ol>
            </div>
          </div>

          {/* Card 3 */}
          <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-2047">
            <div className="px-4 py-3 flex items-center gap-2" style={{
            backgroundColor: '#2E7D32'
          }} data-id="element-2048">
              <PlayIcon className="h-4 w-4 text-white flex-shrink-0" data-id="element-2049" />
              <p className="text-white text-xs font-bold leading-tight" data-id="element-2050">
                SINGLE Class
                <span className="block font-normal text-green-100" data-id="element-2051">
                  One class at a time
                </span>
              </p>
            </div>
            <div className="bg-white px-4 py-4" data-id="element-2052">
              <ol className="space-y-2 text-sm text-slate-700" data-id="element-2053">
                <li className="flex gap-2" data-id="element-2054">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#2E7D32'
                }} data-id="element-2055">
                    1
                  </span>
                  <span data-id="element-2056">
                    Click <strong data-id="element-2057">My Classes</strong> folder
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2058">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#2E7D32'
                }} data-id="element-2059">
                    2
                  </span>
                  <span data-id="element-2060">
                    Click the class <strong data-id="element-2061">Title</strong> to enter
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2062">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#2E7D32'
                }} data-id="element-2063">
                    3
                  </span>
                  <span data-id="element-2064">
                    Click <RedBadge label="YOUR CLASS" data-id="element-2065" /> to begin
                  </span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* 3. TIPS SECTION */}
      <div data-id="element-2066">
        <div className="flex items-center gap-2 mb-4" data-id="element-2067">
          <LightbulbIcon className="h-5 w-5 text-yellow-500" data-id="element-2068" />
          <h2 className="text-lg font-extrabold" style={{
          color: '#4A2D8F'
        }} data-id="element-2069">
            Pro Tips
          </h2>
        </div>

        <div className="space-y-3" data-id="element-2070">
          {/* Tip 1 */}
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-2071">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2072">
              1
            </div>
            <div className="flex items-start gap-3" data-id="element-2073">
              <RefreshCwIcon className="h-4 w-4 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-2074" />
              <div className="text-sm text-slate-700" data-id="element-2075">
                <span className="font-bold text-slate-900" data-id="element-2076">
                  Pick up where you left off.
                </span>{' '}
                You don't have to finish in one sitting. When you log back in,
                you'll return to the section you were working in.{' '}
                <em data-id="element-2077">
                  Click the last tab that is{' '}
                  <span className="text-blue-600 font-semibold" data-id="element-2078">blue</span> to
                  continue.
                </em>
              </div>
            </div>
          </div>

          {/* Tip 2 */}
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-2079">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2080">
              2
            </div>
            <div className="flex items-start gap-3" data-id="element-2081">
              <PauseIcon className="h-4 w-4 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-2082" />
              <div className="text-sm text-slate-700" data-id="element-2083">
                <span className="font-bold text-slate-900" data-id="element-2084">Need to pause?</span>{' '}
                Click the <RedBadge label="Leave/Pause Class" data-id="element-2085" /> button to stop
                the timer.
              </div>
            </div>
          </div>

          {/* Tip 3 */}
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-2086">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2087">
              3
            </div>
            <div className="flex items-start gap-3" data-id="element-2088">
              <ClockIcon className="h-4 w-4 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-2089" />
              <div className="text-sm text-slate-700" data-id="element-2090">
                <span className="font-bold text-slate-900" data-id="element-2091">
                  Slow reader? No problem.
                </span>{' '}
                If the timer reaches 0 before you finish a section,{' '}
                <strong data-id="element-2092">don't worry</strong> — there is no penalty. Take all the
                time you need.
              </div>
            </div>
          </div>

          {/* Tip 4 */}
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-2093">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2094">
              4
            </div>
            <div className="flex items-start gap-3" data-id="element-2095">
              <TimerIcon className="h-4 w-4 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-2096" />
              <div className="text-sm text-slate-700" data-id="element-2097">
                <span className="font-bold text-slate-900" data-id="element-2098">
                  Stopping for the day?
                </span>{' '}
                Click the <RedBadge label="Leave/Pause Class" data-id="element-2099" /> button to stop
                the timer before you close your browser.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 4. ADRE COMPLIANCE NOTE */}
      <div className="rounded-xl border-l-4 bg-purple-50 border-purple-400 px-5 py-5" data-id="element-2100">
        <div className="flex items-center gap-2 mb-2" data-id="element-2101">
          <ClockIcon className="h-5 w-5" style={{
          color: '#4A2D8F'
        }} data-id="element-2102" />
          <h3 className="font-extrabold text-base" style={{
          color: '#4A2D8F'
        }} data-id="element-2103">
            About the 150-Minute Rule
          </h3>
        </div>
        <p className="text-sm text-slate-700 leading-relaxed" data-id="element-2104">
          To comply with ADRE rules, all 3-hour CE classes are timed for a total
          of <strong data-id="element-2105">150 minutes</strong>. Each section timer starts at 25
          minutes. As long as your class is open and your browser is connected,
          the timer counts down automatically. If you navigate away, close your
          browser, or shut down your computer, <strong data-id="element-2106">the timer pauses</strong>{' '}
          — and picks up exactly where it left off when you return.
        </p>
      </div>
    </div>;
}